/**
 * The name a project's Front cover travels between pages under.
 *
 * React writes a `<ViewTransition>`'s name straight into `view-transition-name`,
 * where a CSS identifier may not start with a digit or carry most punctuation,
 * and a desktop project id promises neither. The prefix starts it with a letter,
 * and every other character outside an identifier's alphabet — the escape
 * character `_` included — is spelled out by its code point, so two ids can
 * never arrive at one name. Two covers under one name make the browser abandon
 * the whole transition rather than animate either.
 */
export const resolveProjectCoverTransitionName = (desktopProjectId: string) =>
  `project-cover-${desktopProjectId.replace(
    // `u`, so a character outside the Basic Multilingual Plane is one match
    // rather than two halves of a surrogate pair.
    /[^a-zA-Z0-9-]/gu,
    // A match is never empty, so the fallback is for the type rather than a case.
    (character) => `_${(character.codePointAt(0) ?? 0).toString(16)}_`,
  )}`;
